<template>
  <div class="container mt-3">
    <b-breadcrumb v-if="!isMe" :items="crumbs" class="mb-2"></b-breadcrumb>
    <div class="d-flex align-items-center mb-3">
      <div class="avatar-wrap">
        <img v-if="profile.avatar_url" :src="profile.avatar_url" class="avatar" />
        <div v-else class="avatar-fallback">{{ initial(profile.user_nick || profile.user_name) }}</div>
      </div>
      <div class="ml-2">
        <div class="h6 mb-1">{{ profile.user_nick || profile.user_name || '(匿名)' }}</div>
        <div class="text-muted small">
          <span class="mr-3 clickable" @click="goFollowings">关注 {{ profile.followings || 0 }}</span>
          <span class="clickable" @click="goFollowers">粉丝 {{ profile.followers || 0 }}</span>
        </div>
      </div>
      <div class="ml-auto" v-if="isMe && canPost">
        <b-button size="sm" variant="primary" @click="goPost">发帖</b-button>
      </div>
      <div class="ml-auto" v-if="!isMe">
        <b-button size="sm" :variant="profile.followed_by_me ? 'secondary' : 'primary'" @click="toggleFollow">{{ profile.followed_by_me ? '已关注' : '关注' }}</b-button>
      </div>
    </div>
    <div class="mb-3" v-if="profile.bio"><small class="text-muted">{{ profile.bio }}</small></div>
    <div v-for="p in posts" :key="p.id" class="mb-3 p-2 border rounded">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <router-link :to="'/community/post/'+p.id"><strong>{{ p.title || '(无标题)' }}</strong></router-link>
          <small class="text-muted ml-2">{{ p.created_time }}</small>
        </div>
        <b-button v-if="isMe" variant="link" size="sm" class="p-0" @click="confirmDel(p)"><img :src="deleteIcon" alt="delete" class="thumb-icon" /></b-button>
      </div>
      <div class="text-muted mt-1">{{ excerpt(p.content) }}</div>
    </div>
    <b-modal ref="delModal" hide-footer title="确认删除">
      <div>确定要删除该帖子吗？</div>
      <div class="mt-3 d-flex justify-content-end">
        <b-button variant="secondary" size="sm" class="mr-2" @click="cancelDel">取消</b-button>
        <b-button variant="danger" size="sm" @click="deleteConfirmed">删除</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
export default {
  data(){ return { posts:[], profile:{}, isMe:false, canPost:false, toDelete:null, deleteIcon: require('assets/img/delete.png'), crumbs:[] } },
  mounted(){ this.init() },
  beforeRouteUpdate(to, from, next){ this.init(); next() },
  methods:{
    init(){ const id = this.$route.params && this.$route.params.id ? parseInt(this.$route.params.id) : 0; const meInfoRaw = localStorage.getItem('user_info'); let meId = 0; let meRoles = [];
      try{ if(meInfoRaw){ const m=JSON.parse(meInfoRaw); meId = m.id || 0; const r = m.roles; meRoles = Array.isArray(r) ? r : String(r||'').split(',').map(s=>s.trim()).filter(Boolean) } }catch(e){ console.warn('parse user_info failed', e) }
      if(id>0 && id!==meId){ this.isMe=false; this.canPost=false; this.loadProfile(id); this.loadPostsByUser(id) } else { this.isMe=true; this.canPost = meRoles.includes('post'); this.loadMyProfile(); this.loadMyPosts() } },
    loadMyProfile(){ request_zzquant({ url:'/user/profile/me', method:'GET' }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.profile=d }) },
    loadProfile(id){ request_zzquant({ url:'/user/profile/'+id, method:'GET' }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.profile=d; this.updateCrumbs(id) }) },
    loadMyPosts(){ request_zzquant({ url:'/user/post/my' }).then(res=>{ const arr=res.data&&res.data.data?res.data.data:[]; this.posts=arr }) },
    loadPostsByUser(id){ request_zzquant({ url:'/user/post/user/'+id }).then(res=>{ const arr=res.data&&res.data.data?res.data.data:[]; this.posts=arr }) },
    // roles 在本地 user_info 中为字符串如 "user,canpost" 或数组
    goPost(){ this.$router.push('/me/post') },
    confirmDel(p){ this.toDelete = p; if(this.$refs.delModal){ this.$refs.delModal.show() } },
    cancelDel(){ this.toDelete = null; if(this.$refs.delModal){ this.$refs.delModal.hide() } },
    deleteConfirmed(){ const p=this.toDelete; if(!p){ return } request_zzquant({ url:'/user/post/delete', method:'POST', data:{ post_id:p.id } }).then(()=>{ this.toDelete=null; if(this.$refs.delModal){ this.$refs.delModal.hide() } if(this.isMe){ this.loadMyPosts() } else { const id = this.profile.id; this.loadPostsByUser(id) } }).catch(()=>{ this.toDelete=null; if(this.$refs.delModal){ this.$refs.delModal.hide() } }) },
    full(u){ if(!u) return ''; if(u.startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    excerpt(html){
      const txt = String(html || '').replace(/<[^>]+>/g,' ').replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim()
      return txt.length > 120 ? (txt.slice(0,120) + '…') : txt
    },
    initial(name){ const s=String(name||'').trim(); return s? s.substr(0,1): '?' },
    toggleFollow(){ const tid = this.profile.id; request_zzquant({ url:'/user/follow/toggle', method:'POST', data:{ target_user_id: tid } }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.profile.followed_by_me = !!d.followed; this.profile.followers = d.followers || this.profile.followers }) },
    goFollowings(){ const uid = this.profile.id; this.$router.push('/user/followings/'+uid) },
    goFollowers(){ const uid = this.profile.id; this.$router.push({ path:'/user/followings/'+uid, query:{ type:'fans' } }) },
    updateCrumbs(){ const name = (this.profile.user_nick || this.profile.user_name || '个人主页'); this.crumbs = [ { text:'首页', to:'/home' }, { text: name, active:true } ] }
  }
}
</script>

<style>
.avatar{ width:40px; height:40px; border-radius:50%; object-fit:cover; border:1px solid #eee; }
.avatar-fallback{ width:40px; height:40px; border-radius:50%; background:#f0f0f0; border:1px solid #ddd; display:flex; align-items:center; justify-content:center; color:#333; font-weight:600; }
.clickable{ cursor:pointer; }
.thumb-icon{ width:18px; height:18px; vertical-align:middle; }
</style>
